import { useMemo } from "react";

import { Sort } from "@assets/requestsTypes";
import { Filters } from "@samskip/frontend-components";

import useDebounceValue from "./useDebounceValue";

export const useDebouncedQueryParams = (
  {
    filters,
    sort,
    searchInput,
    isSelectedCompany,
  }: {
    filters: Filters;
    sort: Sort;
    searchInput: string | null;
    isSelectedCompany: boolean;
  },
  delay?: number
) => {
  const debouncedFilters = useDebounceValue(filters, delay);
  const debouncedSort = useDebounceValue(sort, delay);
  const debouncedSelectedCompany = useDebounceValue(isSelectedCompany, delay);

  return useMemo(
    () => ({
      filters: debouncedFilters,
      sort: debouncedSort,
      searchInput,
      isSelectedCompany: debouncedSelectedCompany,
    }),
    [debouncedFilters, debouncedSort, searchInput, debouncedSelectedCompany]
  );
};
